import { render, staticRenderFns } from "./DetailsCmp.vue?vue&type=template&id=56e5d8ac&scoped=true"
import script from "./DetailsCmp.vue?vue&type=script&lang=js"
export * from "./DetailsCmp.vue?vue&type=script&lang=js"
import style0 from "./DetailsCmp.vue?vue&type=style&index=0&id=56e5d8ac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e5d8ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e5d8ac')) {
      api.createRecord('56e5d8ac', component.options)
    } else {
      api.reload('56e5d8ac', component.options)
    }
    module.hot.accept("./DetailsCmp.vue?vue&type=template&id=56e5d8ac&scoped=true", function () {
      api.rerender('56e5d8ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/partition/cmp/DetailsCmp.vue"
export default component.exports